import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../generics/help';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class Inventory extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);
		this.getHourFormat = this.getHourFormat.bind(this);
		this.getComponents = this.getComponents.bind(this);
		this.getBloodComponent = this.getBloodComponent.bind(this);
		
		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);


		this.state = {
			health_facilities_id:"",
			health_facilities:[],
			component_type:"all",
			components:[],
			blood_components:[],
			blood_component_id:"all",
			status_list:[],
			status:"all",

			component_name:"",
			blood_component_name:"",
			status_name:"",
			group_name:"",
			rh_name:"",
			
			listado:[],
			listado_pdf:[],
			change_check: false,
			columns:[
				{title:'No. Componente'},
				{title:'Grupo & RH'},
				{title:'No. Unidad'},				
				{title:'Componente'},
				{title:'Código Componente'},
				{title:'Volumen (ml)'},
				{title:'F. Caducidad'},
				{title:'Estatus'}
			],
			filename:"Reporte Inventario",
			rhGroup:[],
			group:"all",
			rh:"all",
			date_hour:"",
			total_comp:[],
			medical:"",
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date_hour:aux[0]+' '+hours,
			});
		});

		
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)

		fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		this.getComponents();
		//grupos sanguineos
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		})
		.then(response => {
			this.setState({
		      rhGroup: response
		    });
		})

		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=unit_status&option=name', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					status_list: response
				});
			}
		});

		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	getComponents(){
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					components: response
				});
			}
		});
	}

	getBloodComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component/by_type?type='+this.state.component_type, {
			method:'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				})
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({blood_components:response});
			}
		})
	}

	setTable(){
		
		this.$el = $(this.el);
		
		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdf',
                	title: this.state.filename,
                	orientation:'landscape',
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: 'Fecha de emisión '+this.state.date_hour, margin:[10,0,0,10] });
						doc.content.splice(3, 0, {
							columns:[
								this.state.component_type !== "all" ?
									{text: 'Tipo Componente', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.component_type !== "all" ?
									{text: this.state.component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.blood_component_id !== "all" ?
									{text: 'Componente', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.blood_component_id !== "all" ?
									{text: this.state.blood_component_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.status !== "all" ?
									{text: 'Estatus', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.status !== "all" ?
									{text: this.state.status_name, bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},

								this.state.group !== "all" || this.state.rh !== 'all' ?
									{text: 'Grupo & RH', width:'12%', fontSize:6.5}
								: {text:"", width:0},
								this.state.group !== "all" || this.state.rh !== 'all'?
									{text: (this.state.group_name+' '+this.state.rh_name), bold:1, margin:[0,0,0,10], fontSize:6.5 }
								: {text:"", width:0},
							]
						});

						var head = []
						this.state.columns.map((c, i)=>{
							if(i > 1){
								head.push({text:c.title, style:'tableHeader'})
							}
							
						})

						this.state.listado_pdf.unshift(head);
						var total = ''
						this.state.total_comp.map((t, i)=>(
							total += t.text + ': ' + t.num + (i === this.state.total_comp.length - 1 ? '' : ',  ')
						))

						doc.content[4].table.body = this.state.listado_pdf
						doc.content[4].table.widths=["40%","10%","10%","10%","15%", "15%"];

						doc.content[5] = {
							text:total,
							margin:[5,15,0,0]
						}
						doc.content[6] = {
							text:'Numero Total de Registros : '+this.state.listado.length,
							margin:[5,5,0,0]
            			}
						doc.styles.tableHeader.fontSize = 6.5;
                		doc.defaultStyle.fontSize = 6.5; 

                		//doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
						//FOOTER CON PAGINACION INCLUIDA
						doc.footer = (currentPage, pageCount) => {
							return {
								columns:[
									{ text: 'Página '+currentPage.toString() + ' de ' + pageCount, alignment: 'right', margin:[0,0,50,0] },
									{text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]}
									
								]
								
								
							};
						};

                	} 
            	}
            ],
			data: this.state.listado,
			columns:this.state.columns,
           	order: [],
           	rowGroup: {
	            dataSrc: [ 0, 1 ],
	            startRender: function ( rows, group ) {	
					
	            	var len = rows.data()[0].length-1
					//console.log("grupo:",group, "ROWS DATA", rows.data()[0][0], "diferente a grupo? ",rows.data()[0][0] !== group)
	     			if(rows.data()[0][0] !== group){
	     				return $('<tr/>')
		                    .append( 
		                    	'<td style="background:#e5e5e5;font-weight:bold;font-size:12.5px;padding-left:0">'+
		                    		rows.data()[0][0]+
		                    	'</td>'+
		                    	'<td style="background:#e5e5e5;font-weight:bold;font-size:12.5px;padding-left:0">'+
		                    		rows.data().length+
		                    	'</td>' 
		                    ).append( 
		                    	'<td style="background:#e5e5e5;font-weight:bold;font-size:12.5px;padding-left:0" colspan="'+(len-3)+'">'+
		                    		group+
		                    	'</td>' 
		                    );
	     			}
	            },
	        },
	        columnDefs: [ {
	            targets: [ 1, 0 ],
	            visible: false
	        } ],
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: true,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false

		});

		$('.dataTables_filter').css('float', 'left');
		$('.dt-buttons').css({'float':'right', 'width':'50%'});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
		if(e.target.name === 'component_type'){
			if(e.target.value === 'all'){
				this.setState({blood_component_id:'all', [e.target.name]: e.target.value});
			}else{
				this.setState({
					component_name: e.target.options[e.target.selectedIndex].text
				});
				setTimeout(()=>{
					this.getBloodComponent();
				}, 500);

			}
		}else if(e.target.name === 'blood_component_id'){
			this.setState({
				blood_component_name: e.target.options[e.target.selectedIndex].text
			})
		}else if(e.target.name === 'group'){
			this.setState({
				group_name: e.target.options[e.target.selectedIndex].text,
			})
		}else if(e.target.name === 'rh'){
			this.setState({
				rh_name: e.target.options[e.target.selectedIndex].text,
			})
		}else if(e.target.name === 'status'){
			this.setState({
				status_name: e.target.options[e.target.selectedIndex].text,
			})
		}

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.props.waiting.handleShow('Buscando...');

				var obj = {
					health_facilities_id:this.state.health_facilities_id,
					component_type: this.state.component_type,
					blood_component_id: this.state.blood_component_id,
					status:this.state.status,
					group: this.state.group,
					rh: this.state.rh,
				}
				
				fetch(Config.default.apiGateway.URL+'reports/stock',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					
					if(res.ok){
						return res.json();
					}else{
						this.props.waiting.handleClose();
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({
							listado: [],
						});
						var list = [], list_pdf = [];
						var cont = 0;

						response.res.map((res)=>{
							list.push([
								res.blood_component.component,
								// res.unit.group+(res.unit.rh === 'POSITIVO' ? '+' : 
								//  				res.unit.rh === 'NEGATIVO' ? '-' : ''),
								res.lec != null ? res.unit.group+res.lec +(res.unit.rh === 'POSITIVO' ? '+' : res.unit.rh === 'NEGATIVO' ? '-' : '') : res.unit.group +(res.unit.rh === 'POSITIVO' ? '+' : 
								 				res.unit.rh === 'NEGATIVO' ? '-' : ''),
								res.unit.unit_number,
								res.unit.component_number,								
								res.blood_component.code,
								res.unit.volume,
								moment(res.unit.caducidad).format('DD/MM/YYYY HH:mm'),
								res.status
							])

						})
						console.log(response);
						list.map((l, i)=>{
							console.log("ELE E I",l[0], l[1])
							var index = list_pdf.findIndex(obj =>
								obj[0].text.indexOf(l[0]) !== -1 && obj[0].text.indexOf('\t\t'+l[1]) !== -1
							)
							console.log("INDEX",index)
							if(index === -1){
								list_pdf.push([{
									text:l[0]+'\t\t'+1+'\t\t'+l[1],
									bold:1,
									fillColor:'#e0e0e0',
									colSpan:6
								}])
								cont = 1;							
							}else{
								cont++;	
								list_pdf[index][0].text = l[0]+'\t\t'+(parseInt(cont))+'\t\t'+l[1];
							}

							list_pdf.push([
								{text: l[2], alignment:'center'},
								{text: l[3], alignment:'center'},
								{text: l[4], alignment:'center'},
								{text: l[5], alignment:'center'},
								{text: l[6], alignment:'center'},
								{text: l[7], alignment:'center'}
							])

							
						})

						
						this.setState({
							listado: list,
							listado_pdf:list_pdf,
							total_comp:response.totals
						});

						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);
							
						this.props.waiting.handleClose();
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}
		
		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}


	render(){
		const {t} = this.props;
		const { selectedOption } = this.state;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					Almacén ->
					{t('sidebar.nav.reports.MAIN')} ->
					Inventario
					</h5>
				</div>
				<Help 
					{...this.props}
		            menu={"help_storage"} 
		            submenu={"help_stock"}  />
		            
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								<div className="form-group">
									<span className="span-min">Almacén</span>
									<select className="form-control" name="health_facilities_id" id="health_facilities_id"
										value={this.state.health_facilities_id} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.health_facilities.map((c, i)=>{
											return <option key={i} value={c.id}>
												{c.name}
											</option>
										})}
									</select>
								</div>
								<div className="form-group">
									<span className="span-min">Tipo de Componente</span>
									<select className="form-control" name="component_type" id="component_type"
										value={this.state.component_type} onChange={this.handleChange} required>
										<option value="">Seleccione...</option>
										<option value="all">TODOS</option>
										{this.state.components.map((c, i)=>{
											return <option key={i} value={c.key}>
												{c.name}
											</option>
										})}
									</select>
								</div>

								{this.state.component_type !== 'all' ?
									<div className="form-group">
										<span className="span-min">Componente</span>
										<select type="text" name="blood_component_id" id="blood_component_id" 
											value={this.state.blood_component_id} onChange={this.handleChange}
											className="form-control" required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											{this.state.blood_components.map((h, i)=>{
												return <option key={i} value={h.id}>
													{h.component}
												</option>
											})}
										</select>
									</div>
								:null}
									
									
								<div className="form-group">
									<span className="span-min">Estatus</span>
									<select className="form-control" name="status" id="status" 
										value={this.state.status} onChange={this.handleChange}>
										<option value="all">TODOS</option>
										{this.state.status_list.map((s, i)=>{
											return <option key={i} value={s.key}>
												{s.name}
											</option>
										})}
									</select>
								</div>

								<div className="form-group">
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingLeft:"0"}}>
										<span className="span-min">Grupo</span>
										<select className="form-control"  name="group" id="group"
											value={this.state.group} onChange={this.handleChange} required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											{this.state.rhGroup.map(function(t,index) {
								                return index % 2 === 0 ? 
								                	<option key={index}  value={t.key_group} >
								                  		{t.key_group} 
								                	</option>
								                :null
								            })}
										</select>
									</div>
									<div className="col-xs-12 col-sm-6 form-group" style={{paddingRight:"0"}}>
										<span className="span-min">RH</span>
										<select className="form-control"  name="rh" id="rh"
											value={this.state.rh} onChange={this.handleChange} required>
											<option value="">Seleccione...</option>
											<option value="all">TODOS</option>
											<option value="POSITIVO">POSITIVO</option>
											<option value="NEGATIVO">NEGATIVO</option>
										</select>
									</div>
								</div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10 form-group">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									<div className="col-xs-12" >
										<span style={{marginLeft:"5px"}}>
											Fecha de emisión: 
											<b style={{marginLeft:"5px"}}>{this.state.date_hour}</b>
										</span>
									</div>
									<div className="col-xs-12" style={{fontSize:'11px'}}>
										{this.state.component_type !== 'all' && this.state.component_type !== ""?
											<span>
												Tipo Componente:  
												<b style={{marginLeft:"5px"}}>{this.state.component_name}</b>
											</span>	
										:null}
										{this.state.blood_component_id !== 'all' && this.state.blood_component_id !== ""?
											<span style={{marginLeft:"10px"}}> 
												Componente:  
												<b style={{marginLeft:"5px"}}>{this.state.blood_component_name}</b>
											</span>	
										:null}
										{this.state.status !== 'all' && this.state.status !== ""?
											<span style={{marginLeft:"10px"}}> 
												Estatus:  
												<b style={{marginLeft:"5px"}}>{this.state.status_name}</b>
											</span>	
										:null}
										{this.state.group_name  !== "" || this.state.rh_name !== ""?
											<span style={{marginLeft:"15px"}}>
												Grupo & RH: 
												<b style={{marginLeft:"5px"}}>
													{this.state.group_name+' '+this.state.rh_name}
												</b>
											</span>
										:null}
									</div>
								</div>
								
								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} className={"table"} id="table-to-xls" 
											width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								<div className="col-xs-12">
									{this.state.total_comp.map((t, i)=>(
										<span key={i}>
											<b>{t.text+': '}</b>
											{t.num+(i === this.state.total_comp.length - 1 ? '' : ', ')}
										</span>
									))}
								</div>
								<div className="col-xs-12 form-group">
									<label>Numero Total de Registros : </label>{' '+this.state.listado.length}
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (Inventory);